import { http } from "./http";

export type CryptoPaymentSettings = {
  id?: number;
  provider: string;
  enabled: boolean;
  receiver_wallet_address: string;
  integration_id: string;
};

export async function getCryptoPaymentSettings() {
  const res = await http.get("/api/admin/crypto-payment-settings");
  return res.data;
}

export async function updateCryptoPaymentSettings(
  payload: Partial<CryptoPaymentSettings>
) {
  const res = await http.put("/api/admin/crypto-payment-settings", payload);
  return res.data;
}